import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-unavailable-skucodes-column-molecule',
  templateUrl: './unavailable-skucodes-column-molecule.component.html',
  styleUrls: ['./unavailable-skucodes-column-molecule.component.scss']
})
export class UnavailableSkucodesColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() reportName: any;
  unavailableData: any;
  skuStockDetail: any;

  SKUs(event) {
    if (event?.unavailableSkuCodes?.includes(",")) {
      this.unavailableData = event.unavailableSkuCodes.split(",");
    } else if (event?.skuStockDetail) {
      this.skuStockDetail = JSON.parse(event.skuStockDetail);
    } else {
      this.unavailableData = event.unavailableSkuCodes;
    }
  }
  remove() {
    this.unavailableData = [];
    this.skuStockDetail = null;
  }
}
